export default __webpack_public_path__ + "static/media/stride_logo.74784bf0.svg";